import permissionApi from "@/api/PermissionApi";

const PermissionStore = {
  namespaced: true,
  state: {
    userPermission: null,
  },
  mutations: {
    setUserPermission(state, data) {
      state.userPermission = data;
    },
  },
  actions: {
    listRolePermission({ commit }, data) {
      return permissionApi.listRolePermission(data);
    },
    async listUserPermission(context, data) {
      let result = context.state.userPermission;
      if (result == null) {
        result = await permissionApi.listUserPermission(data);
        context.commit("setUserPermission", result);
      }
      return Promise.resolve(result);
    },
  },
};

export default PermissionStore;
